import React, { useState, useEffect } from "react"
import styled from "styled-components"
import { document, window } from "browser-monads"

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: Arial, sans-serif;

  @media (min-width: 901px) {
    padding: unset;
  }
`
const fadeRight = `linear-gradient(to right, black 80%, transparent);`

const Tabs = styled.div`
  display: flex;
  width: 100%;
  overflow: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
  @media only screen and (max-width: 600px) {
    -webkit-mask-image: ${fadeRight};
    mask-image: ${fadeRight};
    padding-right: 40px;
  }
`

const Tab = styled.span`
  cursor: pointer;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  color: ${({ $active }) => ($active ? "#1F1F23" : "#757575")};
  font-weight: ${({ $active }) => ($active ? "700" : "500")};
  border-bottom: ${({ $active }) => ($active ? "2px solid #1f1f23;" : "unset")};
  line-height: 18px;
  width: max-content;
  text-wrap: nowrap;
  padding: 18px 0;
  margin-right: 16px;

  &:hover {
    border-bottom: 2px solid #1f1f23;
    color: #1f1f23;
  }
  @media (max-width: 850px) {
    font-size: 16px;
    padding: 12px 0;
    margin-right: 18px;
  }
`

const sections = [
  { id: "itinerary", label: "Itinerary" },
  { id: "reviews", label: "Reviews" },
  { id: "dates-and-prices", label: "Dates & Prices" },
  { id: "inclusions", label: "Inclusions" },
  { id: "accommodations", label: "Accommodations" },
  { id: "faq", label: "FAQs" },
]

const Header = () => {
  const [activeTab, setActiveTab] = useState("")

  const scrollTo = (id, label) => {
    const el = document.getElementById(id)
    if (el) {
      let yOffset = id === "itinerary" ? -130 : -200
      if (window.innerWidth < 650) {
        yOffset = id === "itinerary" ? -80 : -150
      }
      const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset
      window.scrollTo({ top: y, behavior: "smooth" })
      setActiveTab(label)

      // Scroll active tab into view on small screens
      if (window.innerWidth < 650) {
        const tabEl = document.querySelector(`[data-tab="${label}"]`)
        tabEl?.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest",
        })
      }
    }
  }

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.pageYOffset

      // Track the currently visible section
      let current = ""
      for (const { id, label } of sections) {
        const el = document.getElementById(id)
        if (el) {
          const top = el.offsetTop - 120
          if (scrollY >= top) {
            current = label
          }
        }
      }

      // Only update state and scroll if the tab has changed
      if (current !== activeTab) {
        setActiveTab(current)

        if (window.innerWidth < 650) {
          const tabEl = document.querySelector(`[data-tab="${current}"]`)
          tabEl?.scrollIntoView({
            behavior: "smooth",
            inline: "center",
            block: "nearest",
          })
        }
      }
    }

    window.addEventListener("scroll", handleScroll, { passive: true })
    return () => window.removeEventListener("scroll", handleScroll)
  }, [activeTab])

  return (
    <Container>
      <Tabs>
        {sections.map(({ id, label }) => (
          <Tab
            key={id}
            data-tab={label}
            $active={activeTab === label}
            onClick={() => scrollTo(id, label)}
          >
            {label}
          </Tab>
        ))}
      </Tabs>
    </Container>
  )
}

export default Header
